module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/good/organize_piles-f3248b1d8c3a3e4879b1167ecea77b47.png";